import type { Event as UserEvent } from "@tandemdiabetes/sugarmate-api-react-client"
import type { MangoQuery } from "rxdb"
import type {
  RxQueryResult,
  UseRxQueryOptions,
} from "rxdb-hooks"
import { useEventLoadingDetails } from "src/contexts/LoadingContexts"
import { useFindWithLoading } from "src/hooks/rxdb"
import { CollectionKey } from "src/types"

export function useFindUserEvents<T extends UserEvent>(
  queryObject: MangoQuery<T>,
  options?: Omit<UseRxQueryOptions, "json">,
): RxQueryResult<T> {
  const loadingContextValue = useEventLoadingDetails()

  return useFindWithLoading<T>(
    loadingContextValue,
    CollectionKey.UserEvent,
    queryObject,
    options,
  )
}
